export enum EntityType {
  ACCOUNT = "ACCOUNT",
  COLLECTION = "COLLECTION",
  ITEM = "ITEM",
}
